// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2108) return "static/chunks/2108-ae3120567975f6e7.js";
	if (chunkId === 9318) return "static/chunks/9318-aa88e1f50c9001bb.js";
	if (chunkId === 6711) return "static/chunks/8e1d74a4-c70fcf4919fa700c.js";
	if (chunkId === 4277) return "static/chunks/4277-70937bcfffbc0f1b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2666":"fcfb803e","3524":"2170a4aa","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"2666":"a64791a8398638cf","2701":"34cab7e9475891dc","3524":"bf11bc4d14d8e1f3","3896":"5a88df3d375ea00f","4316":"fa34d13f53bfedc2","5082":"9a537778852a62f4","5915":"d948885ef9ab0fa1","8436":"cab94b59cca0a8ff","9281":"10393392782b7f67"}[chunkId] + ".js";
};